
// DonationPayments.jsx
import React, { useState } from 'react'
import '../Assets/Css/donationpaymments.css'
import '../Assets/Css/stripepayform.css'
import { Container, Form, Button, Row, Col, Card } from 'react-bootstrap'
import LogoHeaderdonate from '../Assets/Image/Xtra-Grow-Foundation-Logo.png'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import StripeDonationForm from './StripeDonationForm'
import { Toaster,toast } from 'react-hot-toast'
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from 'react-router-dom';


// const stripePromise = loadStripe('pk_test_51RbIfWDGaSCglwdkGqai2O133IyCnPFXsZXFucdreL28KeK4VAxvJTFRBtfKl12WSeAhSlKx7gnevowYkvZ7zgF500Xyy7AVN8')

const public_key =
  'pk_live_51MteljJoifpx9au4p0QaDOHlBkkvRh1N9diW2Kb8obEqmB9qaEKquxmDJgs0IFp7KKA4slyaBwVgaR9IkaLnWQND00581ttxhm'
const stripePromise = loadStripe(public_key)

export default function DonationPayments() {
   const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // 👈 Go back one step
  };
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    pinCode: "",
    amount: "",
  })

  const [showStripeForm, setShowStripeForm] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }



const handleDonateNow = (e) => {
  e.preventDefault();

  const { fullName, email, phone, address, pinCode, amount } = formData;

  if (!fullName || !email || !phone || !address || !pinCode || !amount) {
    toast.error("All fields are required.");
    return;
  }

  const emailPattern = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  if (!emailPattern.test(email)) {
    toast.error("Please enter a valid email address.");
    return;
  }

  if (!/^\d{10}$/.test(phone)) {
    toast.error("Phone number must be 10 digits.");
    return;
  }

  if (Number(amount) <= 0) {
    toast.error("Donation amount must be greater than 0.");
    return;
  }

  // ✅ All validations passed
  setShowStripeForm(true);
};

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      {!showStripeForm ? (
        <div className="min-vh-100 donation-container">
          <Container className="py-2">
            <button onClick={handleBack} className="btn btn-link">
      <BiArrowBack size={20} /> Back
    </button>
           
            <Row className="justify-content-center">
              
              <Col md={9} className="donationpart">
                <div className="text-center mb-4">
                  <img src={LogoHeaderdonate} alt="Logo" className="donation-logo" />
                  <h2 className="donation-title">XtraGrow Foundation, Inc.</h2>
                </div>

                <Row>
                

                  <Col md={7}>
  <Form>
    {/* Full Name */}
    <Form.Group className="mb-3" controlId="fullName">
      <Form.Control
        type="text"
        placeholder="Full Name"
        name="fullName"
        value={formData.fullName}
        onChange={handleChange}
        required
      />
    </Form.Group>

    {/* Email */}
    <Form.Group className="mb-3" controlId="email">
      <Form.Control
        type="email"
        placeholder="Email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        pattern="[^@\s]+@[^@\s]+\.[^@\s]+" // simple email pattern
        title="Please enter a valid email address"
        required
      />
    </Form.Group>

    {/* Phone */}
    <Form.Group className="mb-3" controlId="phone">
      <Form.Control
        type="tel"
        placeholder="Phone Number"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        maxLength={10}
        pattern="\d{10}"
        title="Please enter a 10-digit phone number"
        required
      />
    </Form.Group>

    {/* Address */}
    <Form.Group className="mb-3" controlId="address">
      <Form.Control
        as="textarea"
        rows={3}
        placeholder="Address"
        name="address"
        value={formData.address}
        onChange={handleChange}
        required
      />
    </Form.Group>

    {/* Pin Code */}
    <Form.Group className="mb-3" controlId="pinCode">
      <Form.Control
        type="text"
        placeholder="Pin Code"
        name="pinCode"
        value={formData.pinCode}
        onChange={handleChange}
        required
      />
    </Form.Group>
  </Form>
</Col>


                  <Col md={5}>
                    <Card className="donation-card shadow">
                      <Card.Body>
                        <h4 className="mb-3">Grow Hope with Your Contribution</h4>
                        <p className="mb-4 text-muted">
                          Your support empowers lives and helps us grow a greener, healthier future.
                        </p>

                        <Form.Group className="mb-3">
                          <Form.Control
                            type="number"
                            placeholder="$0"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                            min="1"
                            required
                          />
                        </Form.Group>

                        <div className="d-grid">
                          <Button variant="primary" onClick={handleDonateNow}>
                            Donate Now
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      ) : (
        <Elements stripe={stripePromise}>
          <StripeDonationForm formData={formData} />
        </Elements>
      )}
    </>
  )
}
